export default __webpack_public_path__ + "static/media/T740MANA1.aa839a76.pdf";